// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShopOutlinedSvg from "@ant-design/icons-svg/es/asn/ShopOutlined";
import AntdIcon from '../components/AntdIcon';

var ShopOutlined = function ShopOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShopOutlinedSvg
  }));
};

ShopOutlined.displayName = 'ShopOutlined';
export default React.forwardRef(ShopOutlined);